import accountSettingJa from './accountSetting.json';
import accountTerminationJa from './accountTermination.json';
import appTerminationJa from './appTermination.json';
import barcodeJa from './barcode.json';
import boardJa from './board.json';
import cartJa from './cart.json';
import commonJa from './common.json';
import couponJa from './coupon.json';
import customerServiceJa from './customerService.json';
import errorsJa from './errors.json';
import eventJa from './event.json';
import giftJa from './gift.json';
import inquiryJa from './inquiry.json';
import itemJa from './item.json';
import itemsJa from './items.json';
import linkJa from './link.json';
import mainJa from './main.json';
import noticeJa from './notice.json';
import notificationJa from './notification.json';
import orderJa from './order.json';
import orderLogJa from './orderLog.json';
import orderLogsJa from './orderLogs.json';
import orderReceiptJa from './orderReceipt.json';
import permissionJa from './permission.json';
import pointJa from './point.json';
import prepaidCardJa from './prepaidCard.json';
import shopDetailJa from './shopDetail.json';
import shopListJa from './shopList.json';
import shopLocationJa from './shopLocation.json';
import shopPrepareJa from './shopPrepare.json';
import signInJa from './signIn.json';
import signUpJa from './signUp.json';
import stampJa from './stamp.json';
import termDetailJa from './termDetail.json';

const ja = {
    accountSetting: accountSettingJa,
    accountTermination: accountTerminationJa,
    appTermination: appTerminationJa,
    barcode: barcodeJa,
    board: boardJa,
    cart: cartJa,
    common: commonJa,
    coupon: couponJa,
    stamp: stampJa,
    point: pointJa,
    prepaidCard: prepaidCardJa,
    customerService: customerServiceJa,
    errors: errorsJa,
    event: eventJa,
    gift: giftJa,
    inquiry: inquiryJa,
    item: itemJa,
    items: itemsJa,
    link: linkJa,
    main: mainJa,
    notice: noticeJa,
    notification: notificationJa,
    order: orderJa,
    orderLog: orderLogJa,
    orderLogs: orderLogsJa,
    orderReceipt: orderReceiptJa,
    permission: permissionJa,
    shopDetail: shopDetailJa,
    shopList: shopListJa,
    shopLocation: shopLocationJa,
    shopPrepare: shopPrepareJa,
    signIn: signInJa,
    signUp: signUpJa,
    termDetail: termDetailJa,
};

export default ja;
